import React, { useCallback, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useScript } from "../../hooks"
import { Address } from "../../addressValidator"
import { formatAddressWithApartmentNumber } from "../../utils"
import CommonButtonInternet from "../../components/CommonButton"
import { setFormData } from "../../redux/formSlice"
import { useDispatch, useSelector } from "react-redux"
import { colorTheme } from "../../data/SrtingConstants"

interface ServiceProps {
  onButtonClick: () => void
}
const ServiceAddress: React.FC<ServiceProps> = ({ onButtonClick }) => {
  const [loaded] = useScript(
    "https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js"
  )
  const formData = useSelector((state: any) => state.form)
  const dispatch = useDispatch()
  let onFormStateChanged = useCallback((newFormState: any) => {
    dispatch(setFormData(newFormState))
  }, [])

  let addressChange: any = useCallback(
    (shipping_address: any) => onFormStateChanged({ shipping_address }),
    [onFormStateChanged]
  )

  useEffect(() => {
    let type = window?.pca?.fieldMode?.DEFAULT
    if (loaded && typeof type !== "undefined") {
      let fields = [
        {
          element: "home_new_address_1", // Unique ID for first address input
          field: "Line1",
          mode: window.pca.fieldMode.DEFAULT,
        },

        {
          element: "apartment_1",
          field: "BuildingNumber",
          mode: window.pca.fieldMode.POPULATE,
        },
        {
          element: "apartment_2",
          field: "BuildingNumber",
          mode: window.pca.fieldMode.POPULATE,
        },
      ]
      let options = {
        key: "MM49-DD25-FR41-WY59",
        bar: { showCountry: false, showLogo: true, logoLink: false },
      }
      let control = new window.pca.Address(fields, options)
      control.listen("populate", (a: Address) => {
        addressChange(a)
      })
      return () => {
        control.destroy()
      }
    }
  }, [loaded, addressChange])

  let value: any = formData?.shipping_address
  let formattedAddress: any = value
    ? formatAddressWithApartmentNumber(value)
    : ({} as Address)

  const checkAddress = () => {
    let values: any = formData?.shipping_address
    if (values?.Line1) {
      localStorage.setItem("address_data", JSON.stringify(formData))
      let line2address: any = document.getElementById("line2_address")
      if (line2address) {
        line2address.value = formattedAddress?.SubBuilding || ""
      }
    }
  }
  useEffect(() => {
    checkAddress()
  }, [formData])

  useEffect(() => {
    localStorage.removeItem("address_data")
  }, [])
  return (
    <div className="flex justify-center w-full">
      <div className="bg-white m-5 self-center sm:m-10 md:m-16 lg:flex items-center justify-between p-2 lg:p-1 rounded-3xl text-center w-full max-w-2xl">
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://ws1.postescanada-canadapost.ca/css/addresscomplete-2.30.min.css?key=bw11-fu43-na37-by38"
          />
        </Helmet>

        {/* <div className="flex w-full text-xl md:flex-1 justify-center md:justify-start items-center gap-x-2 sm:gap-x-4"> */}

        <input
          type="text"
          name="line11"
          required
          autoComplete="off"
          defaultValue={formData?.shipping_address?.Line1}
          className="border-none text-lg sm:text-xl font-normal font-tt placeholder:font-tt text-black bg-transparent flex-1 min-w-0 p-2 ml-2  placeholder:text-[#A6A6A6] placeholder:font-medium w-full"
          placeholder="Service Address"
          id="home_new_address_1"
          onBlur={() => {
            setTimeout(() => {
              if (typeof window === "undefined") return
              let ad = document.getElementById("address") as HTMLInputElement
              if (ad) ad.value = ""
              let unitField = document.getElementById(
                "unitField"
              ) as HTMLInputElement
              if (unitField) unitField.value = ""
            }, 700)
          }}
        />
        {/* <div
          className={`text-gray-300 transition-colors duration-200 group-focus-within:text-[${colorTheme.MEDIUM_PURPLE}]`}
        >
          |
        </div> */}
        {/* <input
          type="text"
          autoComplete="off"
          className="border-none font-normal text-lg sm:text-xl font-tt placeholder:font-tt text-black bg-transparent flex-1 min-w-0 p-2  placeholder:text-[#A6A6A6] placeholder:font-normal w-full md:w-auto"
          name="line2"
          id="line2_address"
          placeholder="Unit"
          required
        /> */}
        {/* </div> */}

        {/* <div className="sm:w-auto w-full flex justify-center">
        <CommonButtonInternet
          buttonText="See Plans"
          className="font-bold"
          onClick={onButtonClick}
        />
      </div> */}
      </div>
    </div>
  )
}

export default ServiceAddress
